import { render, staticRenderFns } from "./ListImoveltipoPage.vue?vue&type=template&id=963065c6&"
import script from "./ListImoveltipoPage.vue?vue&type=script&lang=js&"
export * from "./ListImoveltipoPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports